module.exports = __webpack_public_path__ + "static/media/video-bg2.1415f1d3.jpg";